module.exports = __webpack_public_path__ + "img/1.c4c95b27.jpg";